export enum FiatCurrencyExchangeSource {
  VamPrivet = 'vamprivet',
  Cbr = 'cbr',
  Rate166 = 'rate166',
  Manual = 'manual',
}
